/**
 * AsroTrack-style helpers: apply config_de_view JSON to MUI DataGrid columns.
 */

export function parseViewConfig(raw) {
  if (!raw) return null;
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function applyConfigToColumns(config, baseColumns) {
  const cols = config?.grid?.columns;
  if (!Array.isArray(cols) || cols.length === 0) {
    return baseColumns.map((c) => ({ ...c }));
  }
  const byName = Object.fromEntries(cols.map((c) => [c.name, c]));
  return baseColumns.map((col) => {
    const cfg = byName[col.field];
    if (!cfg) return { ...col };
    const width = cfg.width != null ? Number(String(cfg.width).replace(/px$/i, '')) : col.width;
    return {
      ...col,
      headerName: cfg.title || col.headerName,
      width: Number.isFinite(width) && width > 0 ? width : col.width,
      hide: cfg.visible === false,
    };
  });
}

export function columnsToConfigJson(category, columns, viewName = 'Custom') {
  return JSON.stringify({
    category,
    view_name: viewName,
    grid: {
      columns: columns.map((c) => ({
        name: c.field,
        title: c.headerName || c.field,
        visible: c.hide !== true,
        width: String(c.width || 120),
      })),
    },
  });
}

export function toColumnVisibilityModel(columns) {
  const model = {};
  columns.forEach((c) => {
    if (c.hide) model[c.field] = false;
  });
  return model;
}
